import React, { useRef, useEffect, useCallback } from 'react';
import { gsap } from '../../../../gsap';
import './Torso.scss';
import HighlightedCopy from '../../../Common/CopyBlocks/HighlightedCopy';
import CopyWithBar from '../../../Common/CopyBlocks/CopyWithBar';

function FutureTorso({ screenWidth }) {
  const futureTorsoSection = useRef();
  const futureTorsoCanvas = useRef();
  const futureTorsoAnimation = useRef();
  const images = useRef([]);
  const ratio = useRef();
  const highlight1 = useRef();
  const highlight2 = useRef();
  const highlighted = [
    {
      copy: 'Morgan Stanley’s speculative suit concept, The Access I, includes air bladders in the HUT’s chest cavity. ',
      ref: highlight1
    },
    {
      copy: 'These can be inflated or deflated to accommodate different torso shapes and sizes.',
      ref: highlight2
    }
  ];
  const withBar =
    "Other forward-looking designs imagine suits that can be easily resized on the ISS itself, adapting to changes astronauts' bodies undergo in microgravity.";

  const playOnScroll = useCallback(() => {
    ratio.current = 1.77;
    images.current = [];
    // set canvas properties
    const canvas = futureTorsoCanvas.current.getContext('2d');
    // Set the size of the canvas
    futureTorsoCanvas.current.width =
      screenWidth > 480 ? Math.min(window.innerWidth * 0.3, 486) : window.innerWidth;
    futureTorsoCanvas.current.height = futureTorsoCanvas.current.width * ratio.current;

    // Count the frames and set the path to the images
    const frameCount = 45;
    const currentFrame = (index) =>
      `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/future/torso/ACCESS_CHEST${(
        index + 1
      )
        .toString()
        .padStart(2, '0')}.png`;
    // Set start frame

    const torso = {
      frame: 0
    };

    // Go through frames from start to finish
    const torsoAnim = gsap.timeline({
      scrollTrigger: {
        trigger: futureTorsoSection.current,
        start: 'top top',
        endTrigger: futureTorsoSection.current,
        end: 'bottom bottom',
        scrub: 1
      }
    });

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.current.push(img);
    }

    torsoAnim.add('start').to(
      torso,
      {
        frame: frameCount - 1,
        snap: 'frame',
        duration: 5,
        ease: 'linear',
        onUpdate: render
      },
      'start'
    );

    images.current[0].onload = render;

    function render() {
      canvas.clearRect(0, 0, futureTorsoCanvas.current.width, futureTorsoCanvas.current.height);
      canvas.drawImage(
        images.current[torso.frame],
        0,
        0,
        futureTorsoCanvas.current.width,
        futureTorsoCanvas.current.height
      );
    }
  }, [screenWidth, images]);

  useEffect(() => {
    playOnScroll();
  }, [playOnScroll]);

  return (
    <section className="torso torso-future" ref={futureTorsoSection}>
      <div className="torso__upper torso__upper-future">
        <HighlightedCopy copyData={highlighted} />
        <div className="torso__textWBar-desktop">
          <CopyWithBar copyData={withBar} />
        </div>
      </div>
      <div className="torso__lower torso__lower-future">
        <div className="torso__animation torso__animation-future" ref={futureTorsoAnimation}>
          <canvas className="torso__animation__canvas" ref={futureTorsoCanvas} />
        </div>
        <div className="torso__textWBar-mobile">
          <CopyWithBar copyData={withBar} />
        </div>
      </div>
    </section>
  );
}

export default FutureTorso;
